module.exports = __webpack_public_path__ + "static/media/reactLogo.6c8ae7fc.png";